<template>
  <div id="app">
    <network-status />
    <router-view />
  </div>
</template>

<script>
import NetworkStatus from '@/components/NetworkStatus.vue'

export default {
  components: {
    NetworkStatus
  }
}
</script>

<style scoped>

</style>
